import { render, staticRenderFns } from "./CarModel.vue?vue&type=template&id=2f22404d&scoped=true&"
import script from "./CarModel.vue?vue&type=script&lang=js&"
export * from "./CarModel.vue?vue&type=script&lang=js&"
import style0 from "./CarModel.vue?vue&type=style&index=0&id=2f22404d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22404d",
  null
  
)

export default component.exports